/* =========================================================================
   SENİN KUTUM — Header davranışları
   NOT: Scroll'da Katman 1/3/4'ü gizleyen özel sticky JS KALDIRILDI.
   Sebep: display:none ile layout zıplaması → header titremesi.
   Artık Dawn'ın kendi sticky-header'ı kullanılıyor (arama+logo yukarıda sabit).
   Bu dosya ileride başka header davranışı gerekirse diye korundu.
   ========================================================================= */
(function () {
  'use strict';
  // Şu an aktif bir davranış yok. (Gerekirse buraya eklenir.)
})();
